import { Category, Home, OrderReview, PaymentSuccess } from "views/dayPassesView"

const menu = [
  {
    link: "/",
    component: Home
  },
  {
    link: "/:value",
    component: Category
  },
  {
    link: "/:value/order-review",
    component: OrderReview
  },
  {
    link: "/success",
    component: PaymentSuccess
  },
  {
    link: "/thank-you/:slug",
    component: PaymentSuccess
  }
]

export default menu